import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  CircularProgress,
} from "@mui/material";
import { getMethod } from "../../../services/apiService";
import { getUserId, epochToFormattedDate } from "../../../helper/helper";
import { getUserPriority } from "../../../services/authService";
import { usePartnerIdContext } from "../../../context/partnerIdContext";
import { Link } from "react-router-dom";
import search from "../../../assets/images/icon/search.svg";
import { PROFILE_TYPE } from "../../../helper/globalConstant";

interface LicenseData {
  distributorLicense: {
    key: string;
    partner: string;
    data: {
      name: string;
      quantity: number;
      createdTime: number;
      activationTime: number;
      expiryTime: number;
      status: number;
      licenseType: number;
      analyticType: number;
    };
  };
  countData: {
    total: number;
    active: number;
    available: number;
  };
}
function LicenseTabOne() {
  //const [licenseData, setLicenseData] = useState<LicenseData[]>([]);
  const [licenseData, setLicenseData] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [loader, showLoader] = useState(true);

  const handleCheckboxChange = (licenseKey: any) => {
    setSelectedRows((prev: any) =>
      prev.includes(licenseKey)
        ? prev.filter((key: any) => key !== licenseKey)
        : [...prev, licenseKey],
    );
  };

  const isRowSelected = (licenseKey: any) => selectedRows.includes(licenseKey);

  const [isPartner, setIsPartner] = useState<boolean>(false);
  const [value, setValue] = useState(null);
  const [userPriority, setUserPriority] = useState<any>();

  const { partnerId } = usePartnerIdContext();
  const lastFetchedRef = React.useRef<{ partnerInfo: string; timestamp: number } | null>(null);

  useEffect(() => {
    fetchCustomerList();
    const storedValue = localStorage.getItem("userInfo");
    if (storedValue) {
      setValue(JSON.parse(storedValue)?.email);
    }
    setUserPriority(getUserPriority());
  }, [partnerId]);

  let user = getUserId();

  const [filteredData, setFilteredData] = useState<any[]>([]);
  const fetchCustomerList = async () => {
    let partnerInfo: any;
    let isPartnerOrTechnician = false;
    const sess_user_data = localStorage.getItem("sess_user");
    if (sess_user_data != null) {
      try {
        const sess_user = JSON.parse(sess_user_data);
        const extractedProfileId = sess_user?.userProfile;
        if (extractedProfileId) {
          const priority = extractedProfileId?.priority;
          if (
            priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G1 ||
            priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G2
          ) {
            partnerInfo = extractedProfileId?.ownerId || getUserId();
            isPartnerOrTechnician = true;
          } else if (
            priority == PROFILE_TYPE.SUPER_ADMIN
          ) {
            partnerInfo = partnerId;
          } else if (priority == PROFILE_TYPE.INTEGRATOR) {
            partnerInfo = partnerId || getUserId();
            isPartnerOrTechnician = true;
          } else {
            // For other roles (like DISTRIBUTOR)
            partnerInfo = partnerId || getUserId();
          }
        } else {
          console.error("Priority id not found in userProfile");
        }
      } catch (error) {
        console.error("Error parsing session user data:", error);
      }
    }

    if (!partnerInfo) {
      showLoader(false);
      return;
    }

    const now = Date.now();
    if (
      lastFetchedRef.current &&
      lastFetchedRef.current.partnerInfo === partnerInfo &&
      now - lastFetchedRef.current.timestamp < 1000
    ) {
      return;
    }
    lastFetchedRef.current = { partnerInfo, timestamp: now };

    setIsPartner(isPartnerOrTechnician);

    const apiEndpoint = isPartnerOrTechnician
      ? `/partner/order/partnerid/details/${partnerInfo}`
      : `distributor/license/available/${partnerInfo}`;

    const resp = await getMethod(apiEndpoint);
    if (resp?.data?.code === 200) {
      setFilteredData(resp?.data?.result);
      setLicenseData(resp?.data?.result);
      showLoader(false);
    } else {
      showLoader(false);
    }
  };

  const [searchText, setSearchText] = useState("");
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;
    setSearchText(query);
    const trimmed = query.trim();
    if (!trimmed) {
      setFilteredData(licenseData);
      return;
    }
    const lowerSearchText = trimmed.toLowerCase();
    const filtered = licenseData.filter((item) => {
      let name = "";
      if (isPartner) {
        name = item?.orderFeature?.featureName || item?.partnerOrder?.data?.[0]?.featureName || "";
      } else {
        name = item?.distributorLicense?.data?.name || item?.license?.data?.name || "";
      }
      const available = item?.countData?.available ?? 0;

      return (
        name.toLowerCase().includes(lowerSearchText) ||
        available.toString().includes(lowerSearchText)
      );
    });

    setFilteredData(filtered); // Update the filtered data state
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignContent: "space-between",
          justifyContent: "space-between",
          gap: "32px",
          padding: "1rem",
        }}
      >
        <div
          style={{
            width: 468,
            height: 41,
            padding: 12,
            borderRadius: 30,
            border: "1px solid #5a5f60",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "#1F2F34",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <img src={search} alt="Search Icon" style={{ cursor: "pointer" }} />
            <input
              onChange={handleSearch}
              placeholder="Search by feature, availability."
              style={{
                background: "#1F2F34",
                border: "none",
                padding: 0,
                margin: 0,
                marginLeft: 8,
                color: "#FFF",
                width: 368,
              }}
            />
          </div>
        </div>
        {userPriority !== PROFILE_TYPE.SUPER_ADMIN && (
          <Link
            to="/orders/create"
            style={{
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <button className="add-btn" style={{ cursor: "pointer" }}>
              {userPriority === PROFILE_TYPE.DISTRIBUTOR
                ? "Create New Partner Order"
                : "Create New Site Order"}
            </button>
          </Link>
        )}
      </Box>
      <TableContainer
        component={Paper}
        sx={{ backgroundColor: "#03171f", padding: "1rem" }}
      >
        <Table sx={{ backgroundColor: "#03171f", border: "1px solid #313838" }}>
          {/* Table Header */}
          <TableHead>
            <TableRow style={{ borderBottom: "2px solid #313838" }}>
              <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Feature
              </TableCell>
              <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Quantity
              </TableCell>
              <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Available
              </TableCell>
              <TableCell
                sx={{
                  color: "#E2E3E3",
                  borderColor: "#313838",
                  fontWeight: "500",
                  fontSize: "16px",
                }}
              >
                Active
              </TableCell>
              {isPartner && (
                <>
                  <TableCell
                    sx={{
                      color: "#E2E3E3",
                      borderColor: "#313838",
                      fontWeight: "500",
                      fontSize: "16px",
                    }}
                  >
                    License Key
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#E2E3E3",
                      borderColor: "#313838",
                      fontWeight: "500",
                      fontSize: "16px",
                    }}
                  >
                    Issue Date
                  </TableCell>
                  <TableCell
                    sx={{
                      color: "#E2E3E3",
                      borderColor: "#313838",
                      fontWeight: "500",
                      fontSize: "16px",
                    }}
                  >
                    Expiry Date
                  </TableCell>
                </>
              )}
            </TableRow>
          </TableHead>

          {/* Table Body */}
          <TableBody>
            {filteredData?.length > 0 ? (
              filteredData?.map((item, index) => {
                const partnerDetail = item?.orderFeature || item?.partnerOrder?.data?.[0];
                return (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: isRowSelected(index)
                        ? "#1a2a2f"
                        : "inherit",
                      cursor: "pointer",
                    }}
                  >
                    <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                      {isPartner
                        ? partnerDetail?.featureName
                        : item?.distributorLicense?.data?.name}
                    </TableCell>
                    <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                      {item?.countData?.total}
                    </TableCell>
                    <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                      {item?.countData?.available}
                    </TableCell>
                    <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                      {item?.countData?.active ?? item?.countData?.assigned}
                    </TableCell>
                    {isPartner && (
                      <>
                        <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                          {partnerDetail?.licenseKey || "-"}
                        </TableCell>
                        <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                          {epochToFormattedDate(partnerDetail?.createdAt)}
                        </TableCell>
                        <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                          {epochToFormattedDate(partnerDetail?.expiry)}
                        </TableCell>
                      </>
                    )}
                  </TableRow>
                );
              })
            ) : (
              <TableRow sx={{ background: "#192529" }}>
                <TableCell
                  sx={{
                    color: "#E2E3E3",
                    borderColor: "#313838",
                    margin: "0",
                    textAlign: "center",
                  }}
                  colSpan={isPartner ? 7 : 4}
                >
                  {loader ? <CircularProgress color="primary" /> : "No Data!"}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default LicenseTabOne;
